(function () {
function hncInit(root) {
  if (!root || root.dataset.hncReady) return;
  root.dataset.hncReady = '1';
  var data = JSON.parse(root.querySelector('[data-hnc-variants]').textContent);

  /* gallery: one image per view on mobile, two side by side on desktop */
  var track = root.querySelector('[data-hnc-track]');
  var slides = track ? track.children : [];
  var thumbs = root.querySelectorAll('[data-hnc-thumb]');
  var counter = root.querySelector('[data-hnc-counter]');
  var prev = root.querySelector('[data-hnc-prev]'), next = root.querySelector('[data-hnc-next]');
  var current = 0;
  function setActive(i) {
    current = i;
    thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
  }
  function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
  function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
  function go(i) {
    if (!slides.length) return;
    var last = Math.max(0, slides.length - perView());
    if (i > last) i = 0;
    if (i < 0) i = last;
    track.scrollTo({ left: i * step(), behavior: 'smooth' });
    setActive(i);
  }
  function fitCheck() {
    var fits = track.scrollWidth <= track.clientWidth + 2;
    [prev, next].forEach(function (b) { if (b) b.hidden = fits; });
    if (counter) counter.hidden = fits;
  }
  if (track) {
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setActive(Math.round(track.scrollLeft / step())); }, 60);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.dataset.hncThumb, 10)); }); });
  if (prev) prev.addEventListener('click', function () { go(current - 1); });
  if (next) next.addEventListener('click', function () { go(current + 1); });
  if (counter) counter.textContent = '1 / ' + slides.length;
  if (track) { fitCheck(); window.addEventListener('resize', fitCheck); }

  /* lightbox: zoom button or click an image (desktop) */
  var lb = root.querySelector('[data-hnc-lightbox]'), lbImg = root.querySelector('[data-hnc-lightbox-img]');
  function openLb(i) { var src = data.images[i]; if (!src) return; lbImg.src = src; lb.hidden = false; root.querySelector('[data-hnc-lightbox-close]').focus(); }
  function closeLb() { lb.hidden = true; lbImg.src = ''; }
  var zoom = root.querySelector('[data-hnc-zoom]');
  if (zoom) zoom.addEventListener('click', function () { openLb(current); });
  Array.prototype.forEach.call(slides, function (s, i) {
    s.addEventListener('click', function () { if (window.matchMedia('(min-width: 990px)').matches) openLb(i); });
  });
  root.querySelector('[data-hnc-lightbox-close]').addEventListener('click', closeLb);
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });

  /* size selector */
  var form = root.querySelector('[data-hnc-form]');
  var variantInput = root.querySelector('[data-hnc-variant]');
  var customFlag = root.querySelector('[data-hnc-custom-flag]');
  var select = root.querySelector('[data-hnc-select]');
  var list = root.querySelector('[data-hnc-options]');
  var label = root.querySelector('[data-hnc-select-label]');
  var hint = root.querySelector('[data-hnc-hint]');
  var measure = root.querySelector('[data-hnc-measure]');
  var bag = root.querySelector('[data-hnc-bag]');
  var errorEl = root.querySelector('[data-hnc-error]');
  var chosen = data.sizeIndex === null ? 'default' : null;

  function toggleMeasure(on) {
    if (!measure) return;
    measure.hidden = !on;
    measure.classList.toggle('active', on);
    measure.querySelectorAll('input').forEach(function (el) { el.disabled = !on; });
    if (customFlag) customFlag.disabled = !on;
  }
  toggleMeasure(false);

  function openList(open) {
    if (!list) return;
    list.hidden = !open;
    select.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = list.querySelector('[aria-selected="true"]:not([disabled])') || list.querySelector('.hnc-option:not([disabled])'); if (f) f.focus(); }
  }
  if (select) {
    select.addEventListener('click', function () { openList(list.hidden); });
    list.querySelectorAll('[data-hnc-size]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var val = opt.dataset.hncSize;
        list.querySelectorAll('[data-hnc-size]').forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
        if (val === '__custom') {
          chosen = 'custom';
          variantInput.value = data.firstAvailable;
          label.textContent = 'Custom size';
          toggleMeasure(true);
        } else {
          var v = data.variants.find(function (x) { return x.options[data.sizeIndex] === val && x.available; });
          if (!v) return;
          chosen = val;
          variantInput.value = v.id;
          label.textContent = 'Size: ' + val;
          toggleMeasure(false);
        }
        select.classList.remove('is-error');
        if (hint) hint.hidden = true;
        openList(false);
        select.focus();
      });
    });
    document.addEventListener('click', function (e) { if (!list.hidden && !e.target.closest('[data-hnc-sizefield]') && !e.target.closest('[data-hnc-sticky-size]')) openList(false); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !list.hidden) { openList(false); select.focus(); } });
  }

  function needSize() {
    if (chosen) return false;
    select.classList.add('is-error');
    if (hint) hint.hidden = false;
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });
    openList(true);
    return true;
  }

  function validCustom() {
    if (chosen !== 'custom' || !measure) return true;
    var ok = true, first = null;
    measure.querySelectorAll('input[required]').forEach(function (f) {
      var empty = f.value.trim() === '';
      var g = f.closest('.pdp-size-group'), err = g && g.querySelector('.pdp-error');
      if (err) err.style.display = empty ? 'block' : 'none';
      f.classList.toggle('pdp-size-group-input--error', empty);
      if (empty) { ok = false; if (!first) first = f; }
    });
    if (first) { first.focus(); }
    return ok;
  }

  /* add to bag */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (needSize() || !validCustom()) return;
    errorEl.hidden = true;
    bag.disabled = true;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', body: fd,
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || res.errors) { errorEl.textContent = res.description || res.message || 'Sorry, this could not be added.'; errorEl.hidden = false; return; }
      if (cart && cart.renderContents) { cart.renderContents(res); }
      else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      if (typeof updateCartCounters === 'function') updateCartCounters();
    }).catch(function () {
      errorEl.textContent = 'Sorry, something went wrong. Please try again.'; errorEl.hidden = false;
    }).finally(function () { bag.disabled = false; });
  });

  /* mobile sticky bar */
  var sSize = root.querySelector('[data-hnc-sticky-size]'), sBag = root.querySelector('[data-hnc-sticky-bag]');
  if (sSize) sSize.addEventListener('click', function () { if (select) { select.scrollIntoView({ behavior: 'smooth', block: 'center' }); openList(true); } });
  if (sBag) sBag.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else bag.click(); });

  /* size guide pop-up */
  var sgBtn = root.querySelector('[data-hnc-sg-open]'), sg = root.querySelector('[data-hnc-sg]');
  if (sgBtn && sg) {
    var sgClose = function () { if (sg.close) sg.close(); else sg.removeAttribute('open'); };
    sgBtn.addEventListener('click', function () { if (sg.showModal) sg.showModal(); else sg.setAttribute('open', ''); });
    sg.querySelector('[data-hnc-sg-close]').addEventListener('click', sgClose);
    sg.addEventListener('click', function (e) { if (e.target === sg) sgClose(); });
  }

  /* tabs */
  var tabs = root.querySelectorAll('[data-hnc-tab]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t2) {
        var on = t2 === tab;
        t2.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById(t2.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    });
  });

  /* client stories link */
  var stories = root.querySelector('[data-hnc-stories]');
  if (stories) stories.addEventListener('click', function (e) {
    var target = document.querySelector('[id$="__client_reviews"]') || document.querySelector('.shopify-section[id*="client"]');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* delivery estimate (store time, Asia/Dubai); business days skip Sat & Sun */
  var eta = root.querySelector('[data-hnc-eta]');
  if (eta) {
    var days = parseInt(eta.dataset.days, 10) || 0, cutoff = parseInt(eta.dataset.cutoff, 10) || 18, business = eta.dataset.business === 'true';
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); };
    var tick = function () {
      var now = new Date(Date.now() + 4 * 3600 * 1000);
      var cut = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), cutoff, 0, 0));
      var start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      if (now >= cut) { cut = new Date(cut.getTime() + 86400000); start = new Date(start.getTime() + 86400000); }
      var arrive = new Date(start.getTime()), added = 0;
      while (added < days) {
        arrive = new Date(arrive.getTime() + 86400000);
        var wd = arrive.getUTCDay();
        if (!business || (wd !== 0 && wd !== 6)) added++;
      }
      var mins = Math.max(0, Math.floor((cut - now) / 60000));
      eta.querySelector('[data-hnc-eta-date]').textContent = 'Arrives ' + fmt(arrive).replace(',', '');
      eta.querySelector('[data-hnc-eta-left]').textContent = Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
      eta.hidden = false;
    };
    tick(); setInterval(tick, 60000);
  }
}
function hncAll() { document.querySelectorAll('.hnc').forEach(hncInit); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hncAll); else hncAll();
document.addEventListener('shopify:section:load', hncAll);
})();